import { Chip } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"
import clsx from "clsx"
import { t } from "i18next"
import React from "react"
import { Card } from "react-bootstrap"
import SVG from "react-inlinesvg"
import { CardBody } from "../../../../../_metronic/_partials/controls/Card.js"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers/AssetsHelpers.js"
import { TableSkeleton } from "../../../../../component/index.jsx"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { PRIVILEGE_ENUM } from "../../../../../constants/PrivilegeConstants.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { UNIT_STRING } from "../../../../../constants/StringConstant.js"
import { stringFormatting, toThousandConvert } from "../../../../helpers/TextHelper.js"
import { useDetailKpiGoalSettingPage } from "./useDetailKpiGoalSettingPage.js"
import { Link } from "react-router-dom"

export function DetailKpiGoalSettingPage() {
  const page = useDetailKpiGoalSettingPage()

  return (
    <>
      <Card>
        <CardBody>
          {page.FieldOfficer?.kpiGoalThisYearTargetRegional !== undefined ? (
            <>
              <div className="mb-5 pb-5">
                <h2 className="font-weight-bolder text-uppercase">
                  {t("label_regional")} {stringFormatting(page.FieldOfficer?.kpiGoalThisYearTargetRegional?.regional_name)}, {page.year}
                </h2>
                <span className="txt-16 font-weight-medium">
                  {t("label_regional_head")}: {stringFormatting(page.FieldOfficer?.kpiGoalThisYearTargetRegional?.regional_head_name)}
                </span>
              </div>
              <div className="mb-5 mt-5">
                <span className="font-weight-bolder txt-16 text-uppercase">{t("label_plant_target_forecast")}</span>
              </div>
              <table className="table-bordered w-100 mb-5">
                <thead>
                  <tr>
                    <th className="py-5 px-3 bg-disabled text-uppercase">{t("label_plant_type")}</th>
                    <th className="py-5 px-3 bg-disabled text-uppercase">{t("label_planting_target_yearly")}</th>
                    <th className="py-5 px-3 bg-disabled text-uppercase">{t("label_forecast_yearly")}</th>
                  </tr>
                </thead>
                <tbody>
                  {(page.FieldOfficer?.kpiGoalThisYearTargetRegional?.target || []).map((targetItem) => (
                    <tr key={targetItem.plant_type_id}>
                      <td className="py-3 px-3 font-weight-bolder">{stringFormatting(targetItem.plant_type_name)}</td>
                      <td className="py-3 px-3">{stringFormatting(toThousandConvert(targetItem.planting_target), UNIT_STRING.HA)}</td>
                      <td className="py-3 px-3">{stringFormatting(toThousandConvert(targetItem.forecast), UNIT_STRING.HA)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="mb-5 mt-5 d-flex align-items-center justify-content-between">
                <span className="font-weight-bolder txt-16 text-uppercase">{t("label_sub_regional_list")}</span>
              </div>
              <div className="mb-5 mt-5">
                <div className="d-flex align-items-center">
                  {[
                    { label: "1 Tahun", value: null },
                    { label: "Jan", value: 0 },
                    { label: "Feb", value: 1 },
                    { label: "Mar", value: 2 },
                    { label: "Apr", value: 3 },
                    { label: "Mei", value: 4 },
                    { label: "Jun", value: 5 },
                    { label: "Jul", value: 6 },
                    { label: "Agt", value: 7 },
                    { label: "Sep", value: 8 },
                    { label: "Okt", value: 9 },
                    { label: "Nov", value: 10 },
                    { label: "Des", value: 11 },
                  ].map((item) => (
                    <Chip
                      key={item.label}
                      className={clsx(
                        "chip-selected-multiple-input mr-2 cursor-pointer",
                        page.selectedMonth === item.value
                          ? "bg-tertiary-light-green text-primary-green border-primary-green"
                          : "bg-neutral-white text-neutral-gray border-neutral-gray"
                      )}
                      size="medium"
                      label={item.label}
                      onClick={() => page.handleMonthChange(item.value)}
                      style={{
                        borderWidth: 1,
                        borderStyle: "solid",
                      }}
                    />
                  ))}
                </div>
              </div>
              {page.General?.loading ? (
                <TableSkeleton column={5} row={5} />
              ) : (
                <table className="table-bordered w-100 mb-5">
                  <thead>
                    <tr>
                      <th className="py-5 px-3 bg-disabled text-uppercase" style={{ width: "30%" }}>{t("label_sub_regional")}</th>
                      <th className="py-5 px-3 bg-disabled text-uppercase">{t("label_plant_type")}</th>
                      <th className="py-5 px-3 bg-disabled text-uppercase text-center">{t("label_planting_target")}</th>
                      <th className="py-5 px-3 bg-disabled text-uppercase text-center">{t("dropdown_forecast")}</th>
                      <th className="py-5 px-3 bg-disabled text-uppercase text-center" style={{ width: "100px" }}>{t("dropdown_forecast")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(page.FieldOfficer?.pageData ?? []).map((subRegional) => {
                      const cropData = subRegional.crop_data || []
                      const rowSpan = cropData.length + 1
                      const totalPlantingTarget = cropData.reduce((sum, item) => sum + (item.planting_target || 0), 0)
                      const totalForecast = cropData.reduce((sum, item) => sum + (item.forecast || 0), 0)
                      return (
                        <React.Fragment key={subRegional.id}>
                          {cropData.map((cropItem, idx) => (
                            <tr key={cropItem.id}>
                              {idx === 0 && (
                                <td rowSpan={rowSpan} className="px-3" style={{ verticalAlign: "top" }}>
                                  <div className="py-3">
                                    <span className="font-weight-bolder">{stringFormatting(subRegional.sub_regional_name)}</span>
                                    <br />
                                    <span className="text-muted">
                                      {Array.isArray(subRegional.regency_list) ? subRegional.regency_list.join(", ") : ""}
                                    </span>
                                  </div>
                                </td>
                              )}
                              <td className="py-3 px-3">{stringFormatting(cropItem.crop_type)}</td>
                              <td className="py-3 px-3 text-center">{toThousandConvert(cropItem.planting_target)}</td>
                              <td className="py-3 px-3 text-center">{stringFormatting(toThousandConvert(cropItem.forecast), UNIT_STRING.HA)}</td>
                              {idx === 0 && (
                                <td rowSpan={rowSpan} className="px-3 text-center" style={{ verticalAlign: "middle" }}>
                                  {page.privileges.indexOf(PRIVILEGE_ENUM.DETAIL_FIELD_OFFICER) > -1 && (
                                    <Link
                                      to={
                                        RoutesConstants.FIELD_OFFICER.FORECAST_SUBREGIONAL(
                                          subRegional.id,
                                          page.year,
                                          page.regionalId
                                        ) + `?history=true${page.selectedMonth ? `&month=${page.selectedMonth}` : ''}`
                                      }>
                                      <div className="btn btn-icon btn-detail btn-hover-secondary btn-md">
                                        <span className="svg-icon svg-icon-2x svg-icon-primary">
                                          <SVG src={toAbsoluteUrl(ICON_CONSTANTS.EDIT_LIST)} />
                                        </span>
                                      </div>
                                    </Link>
                                  )}
                                </td>
                              )}
                            </tr>
                          ))}
                          <tr className="font-weight-bolder card-header-bg-gray">
                            <td className="py-3 px-3 text-negative-color-2">Total</td>
                            <td className="py-3 px-3 text-negative-color-3 text-center">{toThousandConvert(totalPlantingTarget)}</td>
                            <td className="py-3 px-3 text-negative-color-3 text-center">{stringFormatting(toThousandConvert(totalForecast), UNIT_STRING.HA)}</td>
                          </tr>
                        </React.Fragment>
                      )
                    })}
                  </tbody>
                </table>
              )}
            </>
          ) : (
            <>
              <Skeleton animation="wave" className="rounded mb-3" variant="text" height={36} width={300} />
              <Skeleton animation="wave" className="rounded mb-10" variant="text" height={24} width={200} />
              <Skeleton animation="wave" className="rounded mb-5" variant="rect" height={200} />
            </>
          )}
        </CardBody>
      </Card>
    </>
  )
}
